import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Develop applications that can be managed well in production`}</p>
    </PageDescription>
    <p>{`The `}<Globals name="env" mdxType="Globals" />{` is designed to support best practices for developing cloud-native applications that can be managed well in production, known as `}<a parentName="p" {...{
        "href": "https://www.ibm.com/garage/method/practices/code/build-to-manage"
      }}>{`built to manage`}</a>{`. Such components implement endpoints to make them manageable:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Health`}</strong>{`: The component provides a `}<inlineCode parentName="li">{`/health`}</inlineCode>{` endpoint that answers whether it’s running successfully, `}<inlineCode parentName="li">{`UP`}</inlineCode>{` or `}<inlineCode parentName="li">{`DOWN`}</inlineCode>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Metrics`}</strong>{`: The component provides a `}<inlineCode parentName="li">{`/metrics`}</inlineCode>{` endpoint that answers measurements of both the system and application.`}</li>
      <li parentName="ul"><strong parentName="li">{`Readiness`}</strong>{`: Kubernetes verifies whether a pod is ready to start receiving traffic, typically by probing the component’s `}<inlineCode parentName="li">{`/health`}</inlineCode>{` endpoint.`}</li>
      <li parentName="ul"><strong parentName="li">{`Liveness`}</strong>{`: Kubernetes verifies whether a pod should be restarted, typically by probing the component’s `}<inlineCode parentName="li">{`/health`}</inlineCode>{` endpoint.
Kubernetes and the environment’s Ops tools for monitoring use these endpoints to report the status of the application’s components, which can be used to make the applications self-healing.`}</li>
    </ul>
    <p>{`Another important feature is for components to log a history of their significant actions:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Logging`}</strong>{`: Log status to `}<inlineCode parentName="li">{`stdout`}</inlineCode>{` indicating level of severity (such as `}<inlineCode parentName="li">{`info`}</inlineCode>{`, `}<inlineCode parentName="li">{`debug`}</inlineCode>{`, `}<inlineCode parentName="li">{`warn`}</inlineCode>{`, `}<inlineCode parentName="li">{`error`}</inlineCode>{`, and `}<inlineCode parentName="li">{`fatal`}</inlineCode>{`).`}</li>
    </ul>
    <p>{`The environment’s Ops tools for logging will gather and display this history.`}</p>
    <p>{`An easy way to get started with this architecture is by using one of the `}<a parentName="p" {...{
        "href": "/dev-guide/starterkits"
      }}><Globals name="templates" mdxType="Globals" /></a>{` to create the skeleton for each microservice.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      